function urlAddParam(url, key, value) {
  let hashReg = /#.+$/
  let hash = url.match(hashReg) || []
  hash = hash[0] || ''
  url = url
    .replace(hashReg, '')
    .replace(new RegExp(`[?&]${key}=[^&]*&?`, 'g'), (str) =>
      str[str.length - 1] === '&' ? str[0] : ''
    )
  let linkSymbol = '&'
  if (url.indexOf('?') === -1) {
    linkSymbol = '?'
  }
  return `${url}${linkSymbol}${key}=${value}${hash}`
}

export const urlAddNotNullParams = (url = '', kv = []) => {
  if (!url) return url
  if (kv && Object.prototype.toString.call(kv) === '[object Array]') {
    kv.forEach((item) => {
      if (item && item.key && item.value) {
        let k = item.key
        let v = item.value
        url = urlAddParam(url, k, v)
      }
    })
  }
  if (kv && Object.prototype.toString.call(kv) === '[object Object]') {
    Object.keys(kv).forEach((key) => {
      if (key && kv[key]) {
        let k = key
        let v = kv[key]
        url = urlAddParam(url, k, v)
      }
    })
  }

  return url
}
